import { render, staticRenderFns } from "./Imposto.vue?vue&type=template&id=21c868e9&"
import script from "./Imposto.vue?vue&type=script&lang=js&"
export * from "./Imposto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports